if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      var button_sec = $(".addtocart-btn-trigger .button");

      if (button_sec) {
        button_sec.attr('aria-disabled', true)
          .addClass('disabled')
          .prop('disabled', true)
          .addClass('loading')
          .find('.loading-overlay__spinner').removeClass('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('disabled');
          }
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          document.dispatchEvent(new CustomEvent("cart:added"))
          this.afteraddtocart();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    afteraddtocart() {
      document.querySelector('.product-form__submit').classList.add('added');
      document.querySelector('.product-form__submit span').innerHTML = 'Added';
      document.querySelector("cart-drawer.drawer").classList.add("active");
      document.querySelector("html").classList.add("disable-scroll");
      // document.querySelector('.top-btn').classList.add('show');
      // document.querySelector('.bottom-btn').classList.add('show');
      var elementPosition = document.querySelector('.addons-tab-wrapper')?.offsetTop;

      refreshFsLightbox();
      setTimeout(function () {
        // window.scrollTo({
        //   top: elementPosition - 150, //add your necessary value
        //   behavior: "smooth"  //Smooth transition to roll
        // });
        document.querySelector('.product-form__submit').classList.remove('added');
        document.querySelector('.product-form__submit span').innerHTML = 'Proceed to Checkout';

        var button_sec = $(".addtocart-btn-trigger .button");

        if (button_sec) {
          button_sec.addClass("sec-checkout-btn")
            .removeClass('disabled')
            .prop('disabled', false)
            .attr('aria-disabled', false)
            .find(".loading-overlay__spinner").addClass("hidden");

          button_sec.find('span.button__title').text('Proceed to Checkout');
        }

        document.querySelector('.product-form__submit').classList.add('sec-checkout-btn');

      }, 1500)

    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header_main");
  const trigger = document.querySelector(".product__info-container .product-form__wrap");
  if (!header || !trigger) return;

  const target = trigger.previousElementSibling || document.querySelector(".product__info-container .mobile-sticky-addtocart-btn");
  if (!target) return;

  let ticking = false;
  let isSticky = false;

  function getHeaderHeight() {
    return header.offsetHeight - 1;
  }

  let initialHeaderHeight = getHeaderHeight();
  function updateSticky() {
    const headerHeight = getHeaderHeight();
    const rect = trigger.getBoundingClientRect();

    // Trigger has crossed the top of the viewport
    if (rect.top <= 0) {
      if (!isSticky) {
        isSticky = true;
        target.classList.add("sticky-addtocart-mobile");
        target.style.top = headerHeight + "px";
      } else if (isSticky && initialHeaderHeight != headerHeight) {
        target.style.top = headerHeight + "px";
        initialHeaderHeight = headerHeight;
      }
    } else {
      if (isSticky) {
        isSticky = false;
        target.classList.remove("sticky-addtocart-mobile");
        target.style.top = "";
      }
    }
  }

  if (window.innerWidth <= 1024) {
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          ticking = false;
          updateSticky();
        });
      },
      { passive: true }
    );
  }

  window.addEventListener("resize", updateSticky);

  // Run once on load
  updateSticky();
});
